module.exports = __webpack_public_path__ + "static/media/Suspension.1836310f.webp";